import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/return.png';
import _imports_1 from '../../assets/image/bottom.png';
import _imports_2 from '../../assets/image/up.png';
import _imports_3 from '../../assets/image/serachTow.png';
import _imports_4 from '../../assets/image/close.png';
const _withScopeId = n => (_pushScopeId("data-v-0b27c2af"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_2 = [_hoisted_1];
const _hoisted_3 = {
  class: "tk-serach"
};
const _hoisted_4 = {
  class: "tk-serach-img"
};
const _hoisted_5 = {
  key: 0,
  class: "imgs",
  src: _imports_1,
  alt: ""
};
const _hoisted_6 = {
  key: 1,
  class: "imgs",
  src: _imports_2,
  alt: ""
};
const _hoisted_7 = {
  key: 0,
  class: "tk-select"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "彩色", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "select"
}, [/*#__PURE__*/_createElementVNode("div")], -1));
const _hoisted_10 = [_hoisted_8, _hoisted_9];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "黑白", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_13 = [_hoisted_11, _hoisted_12];
const _hoisted_14 = {
  key: 1,
  class: "tk-icon-serch"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tk-serach-img"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
})], -1));
const _hoisted_16 = [_hoisted_15];
const _hoisted_17 = {
  class: "tk-from-serach flex-between"
};
const _hoisted_18 = {
  class: "tk-from-input"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_20 = [_hoisted_19];
const _hoisted_21 = {
  class: "tk-from-botton"
};
const _hoisted_22 = {
  key: 0,
  class: "station"
};
import { toRefs, watch } from "vue";

import { useRouter } from 'vue-router';
import { reactive, ref } from 'vue';
export default {
  __name: 'search',
  props: {
    returns: {
      type: Boolean,
      default: true
    },
    colors: {
      type: String,
      default: '1'
    }
  },
  emits: ['onSubmit', 'colors'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const route = useRouter();
    watch(() => props.colors, (val, old) => {
      data.activeIndex = val; //父组件传过来的值
    });

    let data = reactive({
      select: false,
      activeIndex: 1
    });
    let searchCont = ref(''); //输入内容
    let onSubmit = () => {
      emits('onSubmit', searchCont.value);
    };
    let close = () => {
      //清除内容
      searchCont.value = '';
    };
    let {
      activeIndex
    } = toRefs(data);
    let selectColor = () => {
      //显示弹窗
      data.select = !data.select;
    };
    let colors = index => {
      data.activeIndex = index;
      emits('colors', index);
    };
    let returnBlack = () => {
      route.back();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: _normalizeClass(__props.returns ? 'tk-mian-serach flex-between' : 'tk-mian-serachs flex-between')
      }, [__props.returns ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "tk-return-up",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(returnBlack) && _unref(returnBlack)(...args))
      }, _hoisted_2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [__props.returns ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "tk-icon",
        onClick: _cache[3] || (_cache[3] = (...args) => _unref(selectColor) && _unref(selectColor)(...args))
      }, [_createElementVNode("span", null, _toDisplayString(_unref(activeIndex) == 1 ? '彩色' : '黑白'), 1), _createElementVNode("div", _hoisted_4, [!_unref(data).select ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : (_openBlock(), _createElementBlock("img", _hoisted_6))]), _unref(data).select ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("ul", null, [_createElementVNode("li", {
        class: _normalizeClass(_unref(activeIndex) == 1 ? 'flex-between active' : 'flex-between'),
        onClick: _cache[1] || (_cache[1] = $event => _unref(colors)(1))
      }, _hoisted_10, 2), _createElementVNode("li", {
        class: _normalizeClass(_unref(activeIndex) == 2 ? 'flex-between active' : 'flex-between'),
        onClick: _cache[2] || (_cache[2] = $event => _unref(colors)(2))
      }, _hoisted_13, 2)])])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16)), _createElementVNode("form", null, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(searchCont) ? searchCont.value = $event : searchCont = $event),
        placeholder: "请输入"
      }, null, 512), [[_vModelText, _unref(searchCont)]]), _unref(searchCont).length != 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "icon",
        onClick: _cache[5] || (_cache[5] = (...args) => _unref(close) && _unref(close)(...args))
      }, _hoisted_20)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", {
        class: "botton",
        onClick: _cache[6] || (_cache[6] = (...args) => _unref(onSubmit) && _unref(onSubmit)(...args))
      }, "搜索")])])])])], 2), __props.returns ? (_openBlock(), _createElementBlock("div", _hoisted_22)) : _createCommentVNode("", true)], 64);
    };
  }
};